import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  '@global': {
    body: {
      margin: 0,
      fontFamily: theme.typography.fontFamily,
    },
    '.ccm-settings-summoner': {
      left: '0.5rem !important',
      bottom: '1rem !important',
      width: 24,
      height: 24,
      [theme.breakpoints.up('sm')]: {
        left: '1rem !important',
        bottom: '1rem !important',
        width: 48,
        height: 48,
      },
    },
  },
  app: {
    position: 'absolute',
    height: '100%',
    width: '100%',
  },
}));

export const Frame = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.app}>{children}</div>;
};

Frame.propTypes = {
  children: PropTypes.node,
};

export default Frame;
